export interface IDelegate {
    (sender: any, ...parameters: any[]): void;
}

export class DelegateBuilder {
    private callees: IDelegate[];

    constructor() {
        this.callees = [];
    }

    invoke(sender: any = null, ...parameters: any[]) {
        for (var i = 0; i < this.callees.length; i++) {
            var callee = this.callees[i];
            callee(sender, parameters);
        }
    }

    contains(callee: IDelegate) : boolean {
        if (!callee)
            return false;

        return this.callees.indexOf(callee) >= 0;
    }

    add(callee: IDelegate): DelegateBuilder {
        if (!callee)
            return this;

        if (!this.contains(callee))
            this.callees.push(callee);

        return this;
    }

    remove(callee: IDelegate): DelegateBuilder {
        if (!callee)
            return this;

        var index = this.callees.indexOf(callee);
        if (index >= 0)
            this.callees.splice(index, 1);

        return this;
    }

    toDelegate() : IDelegate {
        return (sender: any, ...parameters: any[]) => this.invoke(sender, parameters);
    }
}